// Module-level cache of resolved permission lists, keyed by group slug.
// Shared between src/hooks/usePagePermissions.js (which reads/populates it)
// and anywhere a session ends (logout, login, axiosInstance's forced
// session-clear) so the next user in the same tab never reads a previous
// user's cached permissions. Lives in its own module (rather than inside
// usePagePermissions.js) so axiosInstance.js can clear it on 401/403 without
// creating a circular import between the two.
const permissionCache = new Map();

export function getCachedPermissions(groupSlug) {
    return permissionCache.get(groupSlug);
}

export function hasCachedPermissions(groupSlug) {
    return permissionCache.has(groupSlug);
}

export function setCachedPermissions(groupSlug, data) {
    permissionCache.set(groupSlug, data);
}

export function clearPermissionCache() {
    permissionCache.clear();
}

// Every group slug resolved so far this session — used by permissionWatcher.js
// to know which groups to re-check for a stale/changed permission set.
export function getAllCachedGroups() {
    return Array.from(permissionCache.keys());
}
